var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarWithCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 666.667,
    height: 538.667,
    viewBox: "0 0 666.667 538.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M0 2154.99h5672.67v154.16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M270.352 2154.99H-365.93v1526.9h636.282v-1526.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M229.047 3636.32h-553.676v139.16h553.676v-139.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M163.285 3722.54h-422.148v196.25h422.148v-196.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M91.402 3850.86h-278.375v314.34H91.402v-314.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 3572.75H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 3572.75h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 3442.57H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 3442.57h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 3312.38H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 3312.38h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 3182.2H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 3182.2h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 3052.03H38.289v63.55h63.563v-63.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 3052.03h-63.559v63.55h63.559v-63.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 2921.83H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 2921.83h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 2791.66H38.289v63.56h63.563v-63.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 2791.66h-63.559v63.56h63.559v-63.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 2661.47H38.289v63.56h63.563v-63.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 2661.47h-63.559v63.56h63.559v-63.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 2531.28H38.289v63.57h63.563v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 2531.28h-63.559v63.57h63.559v-63.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M101.852 2401.1H38.289v63.58h63.563v-63.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M219.711 2401.1h-63.559v63.58h63.559v-63.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M405.285 2154.99h492.063v1435.03H405.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M832.273 3595.62H470.348v115.11h361.925v-115.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M932.688 3526.38h-562.75v89.43h562.75v-89.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M932.688 3281.36h-562.75v89.43h562.75v-89.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M932.688 3036.35h-562.75v89.44h562.75v-89.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M932.688 2791.34h-562.75v89.44h562.75v-89.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M932.688 2546.32h-562.75v89.43h562.75v-89.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M369.938 2301.34h562.75v89.43h-562.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M720.063 3407.1H433.457v90.71h286.606v-90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M869.156 3407.1H748.102v90.71h121.054v-90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M582.551 3259.34h286.605v-90.71H582.551v90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M433.457 3259.34h121.059v-90.71H433.457v90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M720.063 2921.83H433.457v90.71h286.606v-90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M869.156 2921.83H748.102v90.71h121.054v-90.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M582.551 2762.93h286.605v-90.69H582.551v90.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M433.457 2762.93h121.059v-90.69H433.457v90.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M589.707 2419.33h130.355v90.68H589.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M748.102 2419.33h121.055v90.68H748.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M565.762 2419.33H433.457v90.68h132.305v-90.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M1022.12 2154.99h680.449v1287.77H1022.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M1625.54 3407.1h-526.37v164.06h526.37V3407.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M1558.13 3520.64h-391.57l195.79 484.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 3299.28h-595.38v71.51h595.38v-71.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 3166.28h-595.38v71.52h595.38v-71.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 3033.29h-595.38v71.5h595.38v-71.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 2900.29h-595.38v71.5h595.38v-71.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 2767.3h-595.38v71.5h595.38v-71.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1660.04 2634.29h-595.38v71.51h595.38v-71.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1064.66 2501.28h595.379v71.52H1064.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1064.66 2368.29h595.379v71.5H1064.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M1780.44 2154.99h573.68v1462.86h-573.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M2242.2 3571.53h-349.83v92.65h349.83v-92.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 3445.2H1828.8v114.96h120.68V3445.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 3445.2h-120.68v114.96h120.68V3445.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 3445.2h-120.68v114.96h120.68V3445.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 3288.22H1828.8v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 3288.22h-120.68v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 3288.22h-120.68v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 3131.25H1828.8v114.95h120.68v-114.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 3131.25h-120.68v114.95h120.68v-114.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 3131.25h-120.68v114.95h120.68v-114.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 2974.26H1828.8v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 2974.26h-120.68v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 2974.26h-120.68v114.96h120.68v-114.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 2817.27H1828.8v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 2817.27h-120.68v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 2817.27h-120.68v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1949.48 2660.28H1828.8v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2127.62 2660.28h-120.68v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2305.77 2660.28h-120.68v114.97h120.68v-114.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1828.8 2503.31h120.68v114.961H1828.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2006.94 2503.31h120.68v114.961h-120.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2185.09 2503.31h120.68v114.961h-120.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M1828.8 2346.32h120.68v114.98H1828.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2006.94 2346.32h120.68v114.98h-120.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2185.09 2346.32h120.68v114.98h-120.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M3376.38 2154.99h-923.52v1470.29l923.52 433.8V2154.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M3214.75 3607.07h-600.29v679.35h600.29v-679.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3165.99 4172.9h-502.76v35.36h502.76v-35.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3165.99 4094.84h-502.76v35.37h502.76v-35.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3165.99 4016.81h-502.76v35.35h502.76v-35.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2643.49 3497.81h-97.81v97.81h97.81v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2803.5 3497.81h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2963.53 3497.81h-97.83v97.81h97.83v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3123.54 3497.81h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3283.55 3497.81h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2643.49 3307.14h-97.81v97.81h97.81v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2803.5 3307.14h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2963.53 3307.14h-97.83v97.81h97.83v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3123.54 3307.14h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3283.55 3307.14h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2643.49 3116.47h-97.81v97.81h97.81v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2803.5 3116.47h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2963.53 3116.47h-97.83v97.81h97.83v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3123.54 3116.47h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3283.55 3116.47h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2643.49 2925.8h-97.81v97.81h97.81v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2803.5 2925.8h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2963.53 2925.8h-97.83v97.81h97.83v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3123.54 2925.8h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3283.55 2925.8h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2643.49 2735.12h-97.81v97.81h97.81v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2803.5 2735.12h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2963.53 2735.12h-97.83v97.81h97.83v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3123.54 2735.12h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3283.55 2735.12h-97.82v97.81h97.82v-97.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2545.68 2544.46h97.809v97.82h-97.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2705.68 2544.46h97.82v97.82h-97.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2865.7 2544.46h97.832v97.82H2865.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3025.72 2544.46h97.82v97.82h-97.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3185.73 2544.46h97.828v97.82h-97.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2545.68 2353.78h97.809v97.809h-97.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2705.68 2353.78h97.82v97.809h-97.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M2865.7 2353.78h97.832v97.809H2865.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3025.72 2353.78h97.82v97.809h-97.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3185.73 2353.78h97.828v97.809h-97.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M3435.07 2154.99h563.148v1378.8H3435.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M3934.77 3645.69h-436.24v-171.05h436.24v171.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M3851.48 3814.15h-269.67v-236.77h269.67v236.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3434.22h-442.13v40.66h442.13v-40.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3353.3h-442.13v40.65h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3272.35h-442.13V3313h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3191.41h-442.13v40.65h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3110.47h-442.13v40.64h442.13v-40.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 3029.53h-442.13v40.65h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2948.59h-442.13v40.65h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2867.65h-442.13v40.65h442.13v-40.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2786.7h-442.13v40.66h442.13v-40.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2705.78h-442.13v40.62h442.13v-40.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2624.81h-442.13v40.67h442.13v-40.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3937.71 2543.9h-442.13v40.64h442.13v-40.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3495.58 2462.94h442.129v40.64H3495.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M3495.58 2382.02h442.129v40.652H3495.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M4645.72 2154.99h-559.94v1464.95h559.94V2154.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M4602.71 3595.44h-473.92v88.82h473.92v-88.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M4524.14 3639.85h-316.78v310.01h316.78v-310.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M4444.95 3918.49h-158.4v193.87h158.4v-193.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4316.45 3858.59h-45.24v45.22h45.24v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4388.38 3858.59h-45.24v45.22h45.24v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4460.3 3858.59h-45.23v45.22h45.23v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4316.45 3800.56h-45.24v45.22h45.24v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4388.38 3800.56h-45.24v45.22h45.24v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4460.3 3800.56h-45.23v45.22h45.23v-45.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4316.45 3742.51h-45.24v45.23h45.24v-45.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4388.38 3742.51h-45.24v45.23h45.24v-45.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4460.3 3742.51h-45.23v45.23h45.23v-45.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4581.69 3639.85h-431.88v20.76h431.88v-20.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3544.84h-244.54v32.54h244.54v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3544.84H4374.8v32.54h244.57v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3474.88h-244.54v32.54h244.54v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3474.88H4374.8v32.54h244.57v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3404.94h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3404.94H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3334.99h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3334.99H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3265.03h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3265.03H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3195.08h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3195.08H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3125.12h-244.54v32.55h244.54v-32.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3125.12H4374.8v32.55h244.57v-32.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 3055.17h-244.54v32.54h244.54v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 3055.17H4374.8v32.54h244.57v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2985.22h-244.54v32.54h244.54v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2985.22H4374.8v32.54h244.57v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2915.27h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2915.27H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2845.32h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2845.32H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2775.38h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2775.38H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2705.41h-244.54v32.53h244.54v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2705.41H4374.8v32.53h244.57v-32.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2635.46h-244.54V2668h244.54v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2635.46H4374.8V2668h244.57v-32.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2565.52h-244.54v32.52h244.54v-32.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2565.52H4374.8v32.52h244.57v-32.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2495.56h-244.54v32.52h244.54v-32.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2495.56H4374.8v32.52h244.57v-32.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2425.62h-244.54v32.51h244.54v-32.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2425.62H4374.8v32.51h244.57v-32.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4356.71 2355.63h-244.54v32.56h244.54v-32.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4619.37 2355.63H4374.8v32.56h244.57v-32.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M5295.31 3990.37v51.09h-480.5v-51.09h-70.12V2154.99h620.75v1835.38h-70.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3876.19h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3876.19h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3757.57h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3757.57h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3638.96h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3638.96h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3520.34h-158.95v82.97h158.95v-82.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3520.34h-158.96v82.97h158.96v-82.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3401.74h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3401.74h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3283.12h-158.95v82.96h158.95v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3283.12h-158.96v82.96h158.96v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3164.52h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3164.52h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 3045.9h-158.95v82.96h158.95v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 3045.9h-158.96v82.96h158.96v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2927.28h-158.95v82.97h158.95v-82.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2927.28h-158.96v82.97h158.96v-82.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2808.69h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2808.69h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2690.09h-158.95v82.93h158.95v-82.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2690.09h-158.96v82.93h158.96v-82.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2571.46h-158.95v82.96h158.95v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2571.46h-158.96v82.96h158.96v-82.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2452.86h-158.95v82.95h158.95v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2452.86h-158.96v82.95h158.96v-82.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M4939.13 2334.25h-158.95v82.93h158.95v-82.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cceef1",
    stroke: "none",
    d: "M5134.55 2334.25h-158.96v82.93h158.96v-82.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b9568",
    stroke: "none",
    d: "M0 1644.68h5000v746.4c-18.99 7.06-39.43 11.11-60.87 11.11-35.73 0-68.92-10.76-96.61-29.14-17.3 24.69-45.92 40.88-78.35 40.88-31.93 0-60.13-15.71-77.5-39.74-17.14 16.21-40.22 26.22-65.67 26.22-12.4 0-24.21-2.44-35.09-6.74-31.81 32.84-76.28 53.33-125.61 53.33-29.59 0-57.42-7.41-81.84-20.37-9.82 42.4-47.74 74.04-93.12 74.04-24.45 0-46.69-9.24-63.59-24.34-27.32 61.05-88.47 103.65-159.67 103.65-84.85 0-155.56-60.42-171.54-140.58-16.06 12.21-36.03 19.54-57.75 19.54-35.79 0-66.94-19.69-83.34-48.79-31.94 42.18-82.42 69.57-139.42 69.57-61.94 0-116.24-32.28-147.34-80.84-20.68 33.06-57.32 55.13-99.19 55.13-24.41 0-47.06-7.48-65.8-20.25.47 5.27.81 10.6.81 16 0 96.63-78.34 174.96-174.97 174.96-84.55 0-155.09-59.97-171.4-139.71-15.73 7.87-33.43 12.4-52.21 12.4-26.96 0-51.73-9.21-71.51-24.52-11.3 40.24-48.18 69.77-92.01 69.77-40.9 0-75.71-25.72-89.38-61.81-31.15 48.29-85.3 80.34-147.03 80.34-73.27 0-135.94-45.09-161.99-108.99-10.09 3.62-20.91 5.69-32.24 5.69-9.36 0-18.38-1.41-26.92-3.91-8.81 43.74-47.43 76.68-93.76 76.68-19.25 0-37.14-5.73-52.14-15.51-12.07 84.86-84.82 150.17-173 150.17-86.33 0-157.88-62.58-172.19-144.81-12.87 6.44-27.34 10.15-42.72 10.15-8.39 0-16.5-1.19-24.26-3.22-4.18 48.97-45.19 87.42-95.24 87.42-38.76 0-72.06-23.09-87.09-56.25-30.51 25.91-69.95 41.61-113.11 41.61-91.45 0-166.4-70.18-174.19-159.61-10.62 4.07-22.11 6.39-34.17 6.39-52.83 0-95.65-42.82-95.65-95.65 0-12.8 2.55-24.97 7.11-36.12-2.36.17-4.71.36-7.11.36-45.79 0-84.02-32.19-93.4-75.17-1.93.12-3.85.29-5.81.29-11.73 0-22.925-2.21-33.311-6.08a95.67 95.67 0 014.195 28.04c0 52.83-42.832 95.65-95.656 95.65-31.875 0-60.024-15.64-77.407-39.62-17.535 19.98-43.183 32.65-71.839 32.65-40.805 0-75.547-25.6-89.293-61.56-23.075 11.21-48.883 17.67-76.258 17.67-56.883 0-107.27-27.26-139.227-69.31-17.547 20.99-43.898 34.35-73.386 34.35-1.426 0-2.813-.15-4.219-.21.113 1.9.285 3.79.285 5.73 0 52.83-42.828 95.65-95.652 95.65-22.286 0-42.747-7.68-59.004-20.46-31.817 43.61-83.164 72.05-141.278 72.05-24.933 0-48.605-5.29-70.07-14.69v-765.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M4416.64 1850.77l-2663.98 112.61-228.24-228.23 34.82-180.9 626.34-56.48 111.27 76.62 1481.13-144.44 602.44-.04 115.2 231.74-78.98 189.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2026.49 2631.08l115.96 64.54s718.98 36.02 985.47-32.27c0 0 71.76-46.59 102.49-72.5v-14.96h-150.67l.41 34.63-19.41 30s-541.22 60.12-835.33 35.02l-57.82-47.78-141.1-21.78v25.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a171d",
    stroke: "none",
    d: "M1871.96 1367.98c-84.28 0-152.6 68.33-152.6 152.61 0 84.25 68.32 152.59 152.6 152.59s152.6-68.34 152.6-152.59c0-84.28-68.32-152.61-152.6-152.61zm0 411.68c-142.86 0-259.08-116.22-259.08-259.07 0-142.87 116.22-259.1 259.08-259.1 142.85 0 259.07 116.23 259.07 259.1 0 142.85-116.22 259.07-259.07 259.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7075",
    stroke: "none",
    d: "M1993.21 1520.59c0-66.99-54.29-121.25-121.25-121.25-66.97 0-121.26 54.26-121.26 121.25 0 66.97 54.29 121.25 121.26 121.25 66.96 0 121.25-54.28 121.25-121.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7075",
    stroke: "none",
    d: "M2017.48 1471.73l-118.25 54.31 88.19 95.65-24.04 22.17-88.18-95.67-63.74 113.46-28.51-16.02 63.73-113.43-127.58-25.56 6.41-32.07 127.6 25.57-15.14-129.24 32.48-3.8 15.14 129.23 118.22-54.32 13.67 29.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adafae",
    stroke: "none",
    d: "M1871.96 1381.93c-76.57 0-138.65 62.08-138.65 138.66 0 76.56 62.08 138.66 138.65 138.66 76.57 0 138.65-62.1 138.65-138.66 0-76.58-62.08-138.66-138.65-138.66zm0 307.67c-93.36 0-169.04-75.65-169.04-169.01 0-93.35 75.68-169.05 169.04-169.05 93.36 0 169.04 75.7 169.04 169.05 0 93.36-75.68 169.01-169.04 169.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    stroke: "none",
    d: "M2790 2167.94l-62.44 407.86 9.96-.45c279.01-12.75 468.15-38.17 562.11-75.55 14.58-5.57 360.49-140.54 398.94-371.37l1.68-10.08-910.25 49.59m-908.93 49.52l.56 8.27c.24 3.57 27.55 357.48 311.12 357.48l4.59-.03c.23 0 50.02.9 127.52.9 69.29 0 176.42-.75 293.31-4.23l7.55-.24 19.83-403.8-764.48 41.65m2163.47-35.66s-140.61 1.77-224.42 45.76c0 0-403.63 299.02-523.52 347.45 139.88-45.51 377.28-175.57 547.11-273.75-201.01 116.21-496.67 277.1-613.3 289.59 0 0-764.43 95.93-1239.51 36.08 0 0-142.14 7.49-415.23-426.41l-26.18-284.32-56.11-63.59v-209.46l65.86-88.9c16.79 157.85 150.38 280.87 312.72 280.87 173.71 0 314.53-140.83 314.53-314.53 0-7.68-.36-15.28-.91-22.82l7.31-.52 1585.09-67.3a314.282 314.282 0 00-13.33 90.64c0 173.7 140.84 314.53 314.55 314.53 173.7 0 314.54-140.83 314.54-314.53 0-31.55-4.7-61.96-13.32-90.68h.81l194.51 44.9 52.36 299.25s-93.51 254.37-583.56 407.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a171d",
    stroke: "none",
    d: "M4079.2 1367.98c-84.28 0-152.61 68.33-152.61 152.61 0 84.25 68.33 152.59 152.61 152.59 84.28 0 152.6-68.34 152.6-152.59 0-84.28-68.32-152.61-152.6-152.61zm0 411.68c-142.86 0-259.08-116.22-259.08-259.07 0-142.87 116.22-259.1 259.08-259.1 142.85 0 259.08 116.23 259.08 259.1 0 142.85-116.23 259.07-259.08 259.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7075",
    stroke: "none",
    d: "M4200.45 1520.59c0-66.99-54.3-121.25-121.25-121.25-66.97 0-121.28 54.26-121.28 121.25 0 66.97 54.31 121.25 121.28 121.25 66.95 0 121.25-54.28 121.25-121.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7075",
    stroke: "none",
    d: "M4224.71 1471.73l-118.25 54.31 88.21 95.65-24.04 22.17-88.19-95.67-63.75 113.46-28.49-16.02 63.73-113.43-127.59-25.56 6.42-32.07 127.59 25.57-15.14-129.24 32.48-3.8 15.12 129.23 118.25-54.32 13.65 29.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adafae",
    stroke: "none",
    d: "M4079.2 1381.93c-76.6 0-138.66 62.08-138.66 138.66 0 76.56 62.06 138.66 138.66 138.66 76.57 0 138.65-62.1 138.65-138.66 0-76.58-62.08-138.66-138.65-138.66zm0 307.67c-93.36 0-169.03-75.65-169.03-169.01 0-93.35 75.67-169.05 169.03-169.05s169.03 75.7 169.03 169.05c0 93.36-75.67 169.01-169.03 169.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M3435.07 2517.01l-8 5.35c-17.44 7.98-34.39 15.46-50.69 22.34v.01c18.77-7.92 38.42-16.65 58.69-26.02v-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M3376.38 2544.7c-28.91 12.2-55.78 22.5-79.78 30.31 24-7.81 50.87-18.1 79.78-30.3v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M3524.3 2457.23l-8.51 5.71h19.5c-3.74-1.78-7.4-3.68-10.99-5.71m-28.72 19.25l-60.51 40.53v1.68c19.64-9.08 39.88-18.76 60.51-28.9v-13.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M3535.29 2462.94h-19.5l-20.21 13.54v13.31c15.5-7.62 31.21-15.49 47.07-23.57-2.48-1.04-4.94-2.13-7.36-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b6460",
    stroke: "none",
    d: "M3900.34 2216.55c-28.63 6.96-54.6 15.26-71.53 24.92-16.77 12.42-164.24 121.24-303.78 215.28l-.73.48c3.59 2.03 7.25 3.93 10.99 5.71 2.42 1.15 4.88 2.24 7.36 3.28 102-51.95 209.36-111.98 298.47-163.47.05-.02.1-.05.15-.08l.24-.14c.11-.06.23-.13.34-.19.06-.04.12-.08.18-.11.13-.07.27-.15.39-.22.06-.04.14-.09.2-.12.11-.07.23-.13.34-.2.06-.03.14-.07.2-.11.18-.11.37-.21.55-.32-.19.11-.37.21-.55.32-.06.03-.14.08-.2.11-.11.07-.22.13-.34.2-.07.04-.13.07-.2.12-.14.07-.25.14-.39.22-.07.04-.11.06-.18.11-.12.06-.23.13-.34.19l-.24.14c-.06.03-.09.05-.15.08-74.97 43.32-162.87 92.69-249.62 138.21 120.74-63.34 243.69-134.16 330.97-185.73a175.453 175.453 0 01-22.13-38.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35565d",
    stroke: "none",
    d: "M4023.46 2194.7c-33.46 4.38-81.16 11.66-123.12 21.85a175.453 175.453 0 0022.13 38.68c44.72-26.42 80.08-47.79 100.99-60.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37699b",
    stroke: "none",
    d: "M3843.71 2301.26c-.18.11-.37.21-.55.32.18-.11.36-.21.55-.32m-.55.32c-.06.04-.14.08-.2.11.06-.03.14-.08.2-.11m-.2.11c-.11.07-.23.13-.34.2.12-.07.23-.13.34-.2m-.34.2c-.06.03-.14.08-.2.12.07-.05.13-.08.2-.12m-.2.12c-.12.07-.26.15-.39.22.14-.08.25-.15.39-.22m-.39.22c-.06.03-.12.07-.18.11.07-.05.11-.07.18-.11m-.18.11c-.11.06-.23.13-.34.19.11-.06.22-.13.34-.19m-.34.19l-.24.14.24-.14m-.24.14c-.05.03-.1.06-.15.08.06-.03.09-.05.15-.08m-.15.08c-89.11 51.49-196.47 111.52-298.47 163.47a3692.82 3692.82 0 01-47.07 23.57c-20.63 10.14-40.87 19.82-60.51 28.9-20.27 9.37-39.92 18.1-58.69 26.02-28.91 12.2-55.78 22.49-79.78 30.3 77.67-25.26 185.38-76.58 294.9-134.05 86.75-45.52 174.65-94.89 249.62-138.21m-544.52 272.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M3828.81 2241.47c-16.77 12.42-164.24 121.24-303.78 215.28l-97.96 65.61c-48.37 22.12-92.94 40.43-130.47 52.65 119.89-48.43 523.52-347.45 523.52-347.45 83.81-43.99 224.42-45.76 224.42-45.76s-7.51 4.66-21.05 12.9c-56.3 7.36-152.92 22.97-194.68 46.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b94a0",
    stroke: "none",
    d: "M3753.99 1965.04c-.01 147.21-14.39 241.04-14.39 241.04-95.38 166.23-443 332.45-443 332.45-11.11 4.67-24.34 9.04-39.43 13.13 15.09-4.09 28.32-8.46 39.43-13.13 0 0 347.62-166.22 443-332.45 0 0 14.38-93.83 14.39-241.04m-1905.56 251.95s29.97 370.61 307.93 392.41c0 0 66.66 1.12 168.33 1.12 138.07 0 340.66-2.08 528.35-11.89-187.65 9.81-390.16 11.89-528.22 11.89-101.72 0-168.46-1.12-168.46-1.12-277.96-21.8-307.93-392.41-307.93-392.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2328.02 2505.75s130.7 2.83 293.24-1.93l-3.33 67.84c-228.39 6.87-420.7 3.35-420.7 3.35-283.38 3.76-307.45-349.85-307.45-349.85l201-10.94c12.11 84.87 59.98 294.34 237.24 291.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1830.47 2055.66l-8.17.39c-.23 13.54-11.32 24.5-24.92 24.5h-71.96c-11.59 0-21.37-7.97-24.14-18.7l-8.3.4c3.07 15.09 16.45 26.48 32.44 26.48h71.96c18.25 0 33.08-14.83 33.09-33.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c7338",
    stroke: "none",
    d: "M1554.15 2011.44l17.73 192.46 2.99.61c.15.03 1.47.3 3.72.64-.96-1.53-1.95-3.1-2.92-4.63l-17.3-187.88-4.22-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1558.37 2012.64l17.3 187.88c.97 1.53 1.96 3.1 2.92 4.63 4.39.66 12.3 1.6 21.91 1.6 19.97 0 47.27-4.05 65.57-23.08 13.45-13.99 19.79-33.96 18.88-59.32.85-4.55 4.32-31.46-25.55-60.5l-11.82.57c35.15 30.07 29.37 58.26 29.28 58.69l-.13.53.02.55c.94 23.28-4.65 41.39-16.57 53.8-16.25 16.92-41.18 20.55-59.62 20.55-9.4 0-17.11-.95-21.11-1.55l-11.86-128.74-4.07.2-5.15-55.8v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d325b",
    stroke: "none",
    d: "M2095.97 2121.53c0-27.47-59.29-49.71-93.55-49.71-34.25 0-62.03 22.24-62.03 49.71 0 27.47 27.78 49.74 62.03 49.74 34.26 0 93.55-22.27 93.55-49.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2078.13 2121.53c0-13.37-39.35-24.21-62.08-24.21-22.74 0-41.18 10.84-41.18 24.21 0 13.4 18.44 24.23 41.18 24.23 22.73 0 62.08-10.83 62.08-24.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333f7a",
    stroke: "none",
    d: "M2002.42 2171.27c-34.25 0-62.03-22.27-62.03-49.74h155.58c0 27.47-59.29 49.74-93.55 49.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d325b",
    stroke: "none",
    d: "M2980.91 2084.62c0-27.45-59.28-49.72-93.54-49.72-34.26 0-62.05 22.27-62.05 49.72 0 27.48 27.79 49.75 62.05 49.75s93.54-22.27 93.54-49.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2963.08 2084.62c0-13.37-39.35-24.21-62.09-24.21-22.77 0-41.17 10.84-41.17 24.21 0 13.39 18.4 24.25 41.17 24.25 22.74 0 62.09-10.86 62.09-24.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333f7a",
    stroke: "none",
    d: "M2887.37 2134.37c-34.26 0-62.05-22.27-62.05-49.75h155.59c0 27.48-59.28 49.75-93.54 49.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.65 1520.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.74 1521.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.49 1521.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.65 1521.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.65 1521.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.74 1521.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.49 1521.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.65 1522.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.74 1522.26c0 .06-.01.15-.01.21.01-.07.01-.14.01-.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.49 1522.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.65 1522.63c.01.15.01.3.01.45 0-.16 0-.29-.01-.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.73 1522.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.48 1523.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.66 1523.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.73 1523.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.48 1523.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.66 1523.75c0 .09.01.17.01.25 0-.08-.01-.16-.01-.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.67 1524.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.47 1524.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.67 1524.69c.01.13.01.28.01.42 0-.14 0-.29-.01-.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.71 1524.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.46 1524.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.71 1525.27c0 .05-.01.11-.01.15 0-.05.01-.1.01-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.68 1525.37c0 .06.01.13.01.19 0-.07-.01-.12-.01-.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.45 1525.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.69 1525.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.7 1525.86c0 .04 0 .08-.01.12.01-.03.01-.08.01-.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.44 1526.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M3764.7 1526.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4393.69 1526.47c0 .03 0 .04-.01.07.01-.02.01-.05.01-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.43 1526.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.42 1527.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.39 1528.85c0 .02 0 .06-.01.09.01-.04.01-.06.01-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.37 1529.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M2186.31 1531.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1559.29 1554.74c.02.15.03.27.05.42-.02-.14-.03-.28-.05-.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1566.54 1595.92c.03.11.05.22.08.34a4.18 4.18 0 01-.08-.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1566.64 1596.35c.03.13.07.26.1.38-.03-.12-.06-.25-.1-.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1566.79 1596.95c.02.05.03.11.04.16-.01-.04-.03-.11-.04-.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1566.9 1597.4c.01.02.01.04.02.07 0-.02-.01-.06-.02-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c7338",
    stroke: "none",
    d: "M4612.55 1805.07c-6.94 11.95-16.54 26.92-29.46 44.13 12.92-17.21 22.52-32.18 29.46-44.13m-29.49 44.16c-.03.05-.07.1-.1.15.03-.05.07-.1.1-.15m-.15.21c-.03.04-.07.1-.11.15.04-.05.07-.1.11-.15m-.14.18c-.03.05-.08.11-.11.15.04-.05.07-.1.11-.15m-.15.21l-.11.14.11-.14m-.16.2c-.03.04-.06.09-.09.13.03-.05.06-.09.09-.13m-.15.21c-.03.04-.06.07-.09.11.03-.04.06-.07.09-.11m-.15.2c-.03.03-.05.07-.08.1.03-.03.05-.07.08-.1m-.17.22c-.02.03-.03.04-.05.07.02-.03.03-.04.05-.07m-.16.21c-.02.02-.03.04-.04.05.01-.01.02-.03.04-.05m-.15.2c-.01.02-.03.04-.04.06.01-.02.03-.04.04-.06m-.18.23l-.01.01c.01 0 .01 0 .01-.01m-.15.2l-.01.02c0-.01.01-.01.01-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32606d",
    stroke: "none",
    d: "M4620.36 1790.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M1797.38 1958.76h-71.96c-13.74 0-24.92 11.16-24.92 24.9v71.97a25 25 0 00.78 6.22l121.02-5.8v-72.39c0-13.74-11.18-24.9-24.92-24.9m-233.99 63.89l4.2 45.6 79.99-3.83c-16.89-14.45-43.23-29.33-84.19-41.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#327a92",
    stroke: "none",
    d: "M1797.38 1950.57h-71.96c-18.25 0-33.1 14.84-33.1 33.09v71.97c0 2.27.23 4.48.66 6.62l8.3-.4a25 25 0 01-.78-6.22v-71.97c0-13.74 11.18-24.9 24.92-24.9h71.96c13.74 0 24.92 11.16 24.92 24.9v72.39l8.17-.39v-72c0-18.25-14.84-33.09-33.09-33.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#327a92",
    stroke: "none",
    d: "M1558.37 2012.65l5.15 55.8 4.07-.2-4.2-45.6c40.96 12.44 67.3 27.32 84.19 41.77l11.82-.57c-18.15-17.65-48.63-36.08-99.49-50.76l-1.54-.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4628.09 1774.06v.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32606d",
    stroke: "none",
    d: "M4628.07 1774.1399999999999l-.01.01.01-.01m-.01.03c-.01.02-.02.04-.03.07.01-.02.02-.05.03-.07m-.12.31c-.11.27-.27.68-.49 1.22.22-.54.38-.95.49-1.22m-.49 1.23c-.15.35-.32.77-.52 1.24.2-.47.37-.89.52-1.24m-.53 1.25c-.78 1.85-1.97 4.53-3.64 8-.01.02-.02.05-.04.08 1.69-3.5 2.9-6.22 3.68-8.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4628.09 1774.07c-.08.22-1.52 4.06-4.81 10.89 1.67-3.47 2.86-6.15 3.64-8 0 0 .01 0 .01-.01.2-.47.37-.89.52-1.24v-.01c.22-.54.38-.95.49-1.22.03-.09.06-.17.09-.23v-.01c.01-.03.02-.05.03-.07v-.02l.01-.01c0-.01 0-.02.01-.02v-.01c0-.02.01-.03.01-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2186.49 1520.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2186.49 1522.55c0 .2-.01.38-.01.58 0-.19.01-.39.01-.58M2186.48 1523.88c-.01.15-.01.3-.01.45 0-.15 0-.3.01-.45M2186.47 1524.5c0 .15 0 .31-.01.46.01-.15.01-.3.01-.46m-.01.59c0 .2 0 .4-.01.6.01-.2.01-.4.01-.6M2186.45 1525.74c0 .18 0 .36-.01.54.01-.18.01-.36.01-.54m1578.24.26c.01.09.01.21.01.3 0-.1 0-.2-.01-.3m.01.41c1.23 67.95 24.02 130.63 61.81 181.51h.03c-37.79-50.87-60.6-113.56-61.84-181.51m-1578.26.02c0 .15-.01.31-.01.46 0-.16.01-.3.01-.46m-.01.61c-.01.18-.01.35-.01.53 0-.18 0-.35.01-.53m-.01.58l-.03 1.23.03-1.23m-.04 1.32c0 .17 0 .35-.01.52.01-.18.01-.35.01-.52m-.01.61l-.06 1.86.06-1.86m-.06 1.9c-.01.2-.01.4-.02.6.01-.2.01-.4.02-.6m-.02.61c-3.75 104.48-58.49 195.94-140.06 250.35h.08c81.54-54.41 136.23-145.89 139.98-250.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#225b71",
    stroke: "none",
    d: "M2320.74 1571.45c-31.82 0-103.79 12.2-128.95 118.15 25.17-105.94 97.1-118.15 128.94-118.15 9.53 0 15.47 1.09 15.47 1.09s-5.93-1.09-15.46-1.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M1566.5199999999998 1595.8500000000001c.01.02.01.05.02.07-.01-.03-.01-.04-.02-.07m.1.41c.01.04.01.05.02.09 0-.03-.01-.06-.02-.09m.12.47c.02.08.03.15.05.22-.02-.07-.03-.14-.05-.22m.09.38c.03.11.05.18.07.29-.02-.1-.04-.19-.07-.29m.09.36c.03.11.05.2.08.31-.03-.1-.05-.21-.08-.31m.08.32c26.66 105.62 106.75 190.01 209.85 222.69l.04-.08c-103.1-32.67-183.23-116.99-209.89-222.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c7338",
    stroke: "none",
    d: "M1493.38 1852.61l55.98 63.45h.01l-55.99-63.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M4393.74 1520.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M4393.73 1523.5799999999997c-.01.38-.01.76-.02 1.14.01-.38.01-.75.02-1.14m-.05 2.96c-1.83 99.01-49.48 186.78-122.59 243.17l.09.04c73.08-56.39 120.66-144.22 122.5-243.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d9dae",
    stroke: "none",
    d: "M4628.1 1774.06h-.01.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32606d",
    stroke: "none",
    d: "M4623.24 1785.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a4d5f",
    stroke: "none",
    d: "M4600.59 1616.86l27.51 157.2-27.51-157.2m22.69 168.1c-.85 1.76-1.82 3.71-2.92 5.86 1.09-2.11 2.04-4.04 2.88-5.78.02-.03.03-.06.04-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2821.62 2498.47c198.4-9.46 404.24-29.22 502.97-70.01 0 0 279.49-111.16 343.95-300.2l22-1.2c-38.18 228.92-393.94 365.17-393.94 365.17-109.82 43.67-338.79 64.88-559.46 74.96l59.94-391.45 72.7-3.96-48.16 326.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M3435.07 2429.48c-15.02 11.67-32.94 19.77-52.52 22.98-2.08 1.09-4.14 2.15-6.17 3.19v9.47c17.79-8.95 37.71-19.59 58.69-31.85v-3.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M3297.7 2433.76c.13 1.45.25 2.9.35 4.36 1.43-.46 2.84-.92 4.23-1.39-1.55-.95-3.08-1.95-4.58-2.97m78.68 21.89c-46.88 23.98-79.78 36.58-79.78 36.58-1.2.47-2.42.95-3.65 1.42-.85 3.3-1.79 6.56-2.83 9.78 3.27-1.2 6.44-2.4 9.51-3.63 4.1-1.56 34.43-13.37 76.75-34.68v-9.47m-547.96 17.24a94.577 94.577 0 01-5.07 13.82l-1.73 11.76c18.98-.91 38.02-1.91 57.03-3.01-18.68-3.46-35.79-11.39-50.23-22.57m123.72 12.12c-5.36 2.68-10.94 4.97-16.71 6.83 6-.42 11.96-.85 17.94-1.29-.44-1.84-.85-3.69-1.23-5.54m-211.23 57.54c-1.49.07-2.99.11-4.5.11-1.26 0-2.52-.03-3.77-.08l-.28 1.88h8.26l.29-1.91m239.71 8.15c-5.68.55-11.36 1.07-17.09 1.59v8.24c7.73-.69 15.34-1.4 22.86-2.13-1.99-2.51-3.91-5.08-5.77-7.7m-114.92 9.27c-20.63 1.4-41.39 2.68-62.2 3.85v8.19c21.32-1.2 42.06-2.47 62.2-3.83v-8.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2740.62 2544.46h-8.26l-4.8 31.34 9.96-.45c22.58-1.03 44.58-2.15 65.98-3.34v-8.19c-22.12 1.24-44.29 2.36-66.36 3.37l3.48-22.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2963.53 2552.29c-31.93 2.89-64.7 5.44-97.83 7.68v8.21c34.33-2.31 66.94-4.86 97.83-7.65v-8.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M3466.16 2404.08c-4.53 2.93-9.05 5.78-13.53 8.56-5.26 6.2-11.14 11.84-17.56 16.84v3.79a965.68 965.68 0 0036.19-22.19c-1.76-2.29-3.46-4.62-5.1-7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b6460",
    stroke: "none",
    d: "M3462.69 2143.66c-20.68 33.07-57.32 55.14-99.19 55.14-24.41 0-47.06-7.48-65.8-20.25.47 5.27.81 10.59.81 15.99 0 96.63-78.34 174.96-174.97 174.96-84.55 0-155.09-59.97-171.4-139.7-15.73 7.87-33.43 12.4-52.21 12.4-13.88 0-27.17-2.44-39.51-6.9l-37.07 251.41c2.03-4.43 3.73-9.05 5.07-13.82 14.44 11.18 31.55 19.11 50.23 22.57 18.98-1.1 37.95-2.3 56.78-3.62 5.77-1.86 11.35-4.15 16.71-6.83.38 1.85.79 3.7 1.23 5.54 136.45-10.13 264.22-26.4 344.68-52.43-.1-1.46-.22-2.91-.35-4.36 1.5 1.02 3.03 2.02 4.58 2.97 7.94-2.66 15.39-5.41 22.31-8.27 0 0 186.14-74.03 289.64-204.01-1.39.04-2.8.05-4.2.05-61.94 0-116.24-32.27-147.34-80.84m206.31 70.6c-3.78 1.36-7.61 2.59-11.5 3.69-43.7 77.35-120.06 140.2-191.34 186.13 1.64 2.38 3.34 4.71 5.1 7 74.37-47.88 154.19-114.23 197.74-196.82m-887.28 61.76a93.438 93.438 0 01-8.92 4.24l-40.16 262.32c1.25.05 2.51.08 3.77.08 1.51 0 3.01-.04 4.5-.11l40.81-266.53m670.91 136.62c-24.84 15.43-48.76 28.75-70.08 39.82 19.58-3.21 37.5-11.31 52.52-22.98 6.42-5 12.3-10.64 17.56-16.84m-159.68 81.01c-69.3 26.62-183.37 44.76-312.33 57.05 1.86 2.62 3.78 5.19 5.77 7.7 138.53-13.39 240.23-31.77 303.73-54.97 1.04-3.22 1.98-6.48 2.83-9.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35565d",
    stroke: "none",
    d: "M3700.25 2118.35L2790 2167.94l-17.2 112.32c3.06-1.26 6.04-2.68 8.92-4.24l15.36-100.28 72.7-3.96-9.36 63.52c12.34 4.46 25.63 6.9 39.51 6.9 18.78 0 36.48-4.53 52.21-12.4 16.31 79.73 86.85 139.7 171.4 139.7 96.63 0 174.97-78.33 174.97-174.96 0-5.4-.34-10.72-.81-15.99 18.74 12.77 41.39 20.25 65.8 20.25 41.87 0 78.51-22.07 99.19-55.14 31.1 48.57 85.4 80.84 147.34 80.84 1.4 0 2.81-.01 4.2-.05 23.33-29.29 42.46-61.42 54.31-96.19l22-1.2c-5.37 32.16-17 62.51-33.04 90.89 3.89-1.1 7.72-2.33 11.5-3.69 14.19-26.91 24.53-55.54 29.57-85.83l1.68-10.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3967",
    stroke: "none",
    d: "M3690.54 2127.06l-22 1.2c-11.85 34.77-30.98 66.9-54.31 96.19-103.5 129.98-289.64 204.01-289.64 204.01-6.92 2.86-14.37 5.61-22.31 8.27-1.39.47-2.8.93-4.23 1.39-80.46 26.03-208.23 42.3-344.68 52.43-5.98.44-11.94.87-17.94 1.29-18.83 1.32-37.8 2.52-56.78 3.62-19.01 1.1-38.05 2.1-57.03 3.01l1.73-11.76 37.07-251.41 9.36-63.52-72.7 3.96-15.36 100.28-40.81 266.53-.29 1.91-3.48 22.73c22.07-1.01 44.24-2.13 66.36-3.37 20.81-1.17 41.57-2.45 62.2-3.85 33.13-2.24 65.9-4.79 97.83-7.68 5.73-.52 11.41-1.04 17.09-1.59 128.96-12.29 243.03-30.43 312.33-57.05 1.23-.47 2.45-.95 3.65-1.42 0 0 32.9-12.6 79.78-36.58 2.03-1.04 4.09-2.1 6.17-3.19 21.32-11.07 45.24-24.39 70.08-39.82 4.48-2.78 9-5.63 13.53-8.56 71.28-45.93 147.64-108.78 191.34-186.13 16.04-28.38 27.67-58.73 33.04-90.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M3459.66 2139.65l16.69-.92-45.56 287.08c-6.16 3.61-12.26 7.1-18.21 10.44l47.08-296.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adafae",
    stroke: "none",
    d: "M1932.99 1520.59c0-33.5-27.14-60.63-60.63-60.63-33.48 0-60.63 27.13-60.63 60.63 0 33.48 27.15 60.61 60.63 60.61 33.49 0 60.63-27.13 60.63-60.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adafae",
    stroke: "none",
    d: "M4136.15 1520.59c0-33.5-27.13-60.63-60.61-60.63-33.49 0-60.65 27.13-60.65 60.63 0 33.48 27.16 60.61 60.65 60.61 33.48 0 60.61-27.13 60.61-60.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2354.12 2482.7v23.46c5.48.07 11.77.13 18.77.2a176.516 176.516 0 01-18.77-23.66m98.74 92.42c-35.62.44-68.83.66-98.74.75v8.17c28.81-.09 62.17-.31 98.74-.76v-8.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M2338.01 2452.2c-10.09 3.62-20.91 5.69-32.24 5.69v3.41h-28.7a95.254 95.254 0 01-17.42 33.62c10.33 3.71 21.27 6.55 32.86 8.39h13.26v1.64c6.08.55 12.32.83 18.74.83 1.17 0 2.33-.01 3.51-.03 0 0 9.34.2 26.1.41v-23.46a175.043 175.043 0 01-16.11-30.5m-210.39 115.84v8.33c17.84 3.94 36.97 6.29 57.47 6.76v-8.18c-20.55-.47-39.66-2.88-57.47-6.91m226.5 7.83a9994.73 9994.73 0 01-48.35.02v8.17c6.16.02 12.53.02 19.09.02 9.12 0 18.9-.01 29.26-.04v-8.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2117.74 2565.6c-1.19 2.49-2.44 4.96-3.74 7.39 4.45 1.23 8.99 2.36 13.62 3.38v-8.33c-3.34-.76-6.63-1.57-9.88-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2305.77 2503.31h-13.26c4.33.69 8.76 1.24 13.26 1.64v-1.64m-120.68 71.64v8.18c2.53.05 5.08.08 7.66.08l4.59-.03c.21 0 41.93.76 108.43.88v-8.17c-67.18-.12-108.54-.88-108.54-.88a322.886 322.886 0 01-12.14-.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2278.85 2453.98c-.5 2.48-1.09 4.92-1.78 7.32h28.7v-3.41c-9.36 0-18.38-1.41-26.92-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406494",
    stroke: "none",
    d: "M2629.45 2503.75c-2.77 3.05-5.65 6.01-8.62 8.86l-1.57 31.85h8.19l2-40.71m-83.77 69.78c-32.25.71-63.37 1.22-92.82 1.59v8.16c29.14-.36 60.32-.87 92.82-1.57v-8.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d6f9f",
    stroke: "none",
    d: "M2627.45 2544.46h-8.19l-1.33 27.2c-24.56.74-48.71 1.36-72.25 1.87v8.18c23.55-.51 47.81-1.12 72.49-1.86l7.55-.24 1.73-35.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b6460",
    stroke: "none",
    d: "M2338.01 2196.98c-10.09 3.63-20.91 5.7-32.24 5.7-9.36 0-18.38-1.41-26.92-3.91-8.81 43.74-47.43 76.68-93.76 76.68-19.25 0-37.14-5.73-52.14-15.52a174.34 174.34 0 01-18.5 57.01c23.52 71.54 66.67 149.8 145.2 177.98a95.254 95.254 0 0019.2-40.94c8.54 2.5 17.56 3.91 26.92 3.91 11.33 0 22.15-2.07 32.24-5.69 4.38 10.74 9.79 20.95 16.11 30.5 5.58 8.42 11.86 16.34 18.77 23.66 15.13.13 33.66.23 54.92.23 51.55 0 119.16-.59 193.45-2.77l-.43 8.79c2.97-2.85 5.85-5.81 8.62-8.86l13.34-271.84c-31.69 44.77-83.77 74.07-142.79 74.07-73.27 0-135.94-45.09-161.99-109m-406.08 210.89c33.81 70.16 89.81 139.61 182.07 165.12 1.3-2.43 2.55-4.9 3.74-7.39-89-23.82-143.55-89.28-176.85-156.52-3.01-.33-6-.73-8.96-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35565d",
    stroke: "none",
    d: "M2645.55 2175.81l-764.48 41.65.56 8.27c.12 1.8 7.12 92.55 50.3 182.14 2.96.48 5.95.88 8.96 1.21-44.75-90.36-51.11-183.92-51.11-183.92l201-10.94c3.69 25.85 10.69 63.26 23.67 102.72a174.34 174.34 0 0018.5-57.01c15 9.79 32.89 15.52 52.14 15.52 46.33 0 84.95-32.94 93.76-76.68 8.54 2.5 17.56 3.91 26.92 3.91 11.33 0 22.15-2.07 32.24-5.7 26.05 63.91 88.72 109 161.99 109 59.02 0 111.1-29.3 142.79-74.07l2.76-56.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3967",
    stroke: "none",
    d: "M2090.78 2214.22l-201 10.94s6.36 93.56 51.11 183.92c33.3 67.24 87.85 132.7 176.85 156.52 3.25.87 6.54 1.68 9.88 2.44 17.81 4.03 36.92 6.44 57.47 6.91a322.886 322.886 0 0012.14.06s41.36.76 108.54.88a9994.73 9994.73 0 0048.35-.02c29.91-.09 63.12-.31 98.74-.75 29.45-.37 60.57-.88 92.82-1.59 23.54-.51 47.69-1.13 72.25-1.87l1.33-27.2 1.57-31.85.43-8.79c-74.29 2.18-141.9 2.77-193.45 2.77-21.26 0-39.79-.1-54.92-.23-7-.07-13.29-.13-18.77-.2-16.76-.21-26.1-.41-26.1-.41-1.18.02-2.34.03-3.51.03-6.42 0-12.66-.28-18.74-.83-4.5-.4-8.93-.95-13.26-1.64-11.59-1.84-22.53-4.68-32.86-8.39-78.53-28.18-121.68-106.44-145.2-177.98-12.98-39.46-19.98-76.87-23.67-102.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2324.86 2592.26c-74.7 0-123.69-.84-127.66-.92-1.48.04-2.99.04-4.45.04h-.04c-120.96.02-214.65-63.74-270.95-184.35-41.66-89.2-48.03-177.07-48.29-180.77l-1.11-16.51 16.53-.92 747.15-40.71 18.11-.97-.89 18.12-18.99 387.2-.74 15.09-15.11.45c-116.98 3.5-224.21 4.25-293.56 4.25zm0-16.37c76.36 0 180.33-.84 293.07-4.23l19-387.21-747.14 40.71s23.75 349.92 302.96 349.88c1.48 0 3 0 4.48-.03 0 0 49.3.88 127.63.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333f7a",
    stroke: "none",
    d: "M1993.21 2219.53v268.27c-92.6-103.62-103.42-262.64-103.42-262.64l103.42-5.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M1898.75 2232.87l86.28-4.71v236.94c-65.83-85.89-82.77-200.77-86.28-232.23zm102.63-21.96l-120.31 6.55.56 8.27c.45 6.58 12.09 163.02 105.48 267.52l14.27 15.98v-298.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M2717.96 2584.42l3.04-19.71 59.93-391.44 2.02-13.15 13.22-.71 893.46-48.67 20.39-1.11-3.37 20.11c-39.24 235.43-389.31 372.04-404.2 377.74-94.6 37.64-284.63 63.24-564.55 76.05zm19.18-17.23c220.67-10.08 449.64-31.29 559.46-74.96 0 0 355.76-136.25 393.94-365.17l-893.46 48.68-59.94 391.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f283e",
    stroke: "none",
    d: "M3486.01 2130.03l-33.39 1.81-50.75 319.77 14.7-8.24c6-3.37 12.16-6.89 18.35-10.52l3.32-1.94.62-3.82 47.15-297.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f47228",
    stroke: "none",
    d: "M4580.8 1852.17c-41.21 54.11-114.73 129.27-240.31 202.35 11.62-36.29 72.25-196.29 240.31-202.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1502c",
    stroke: "none",
    d: "M4580.8 1852.17c-86.19 3.11-144.08 46.72-181.63 93.34 32.86-13.76 76.81-27.42 126.36-30.56 19.89-19.89 36.31-38.63 49.64-55.52 1.94-2.46 3.82-4.88 5.63-7.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30418d",
    stroke: "none",
    d: "M1175.29 2936.04H594.965c-50.832 0-92.039-41.22-92.039-92.05V1353.54h764.414v1490.45c0 50.83-41.21 92.05-92.05 92.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3160",
    stroke: "none",
    d: "M1175.29 2936.04H594.965c-50.832 0-92.039-41.22-92.039-92.05v-56.06c0 50.83 41.207 92.04 92.039 92.04h580.325c50.84 0 92.05-41.21 92.05-92.04v56.06c0 50.83-41.21 92.05-92.05 92.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M1187.39 2163.86c0-50.84-41.21-92.04-92.05-92.04H674.906c-50.836 0-92.039 41.2-92.039 92.04v253.34c0 50.83 41.203 92.03 92.039 92.03h420.434c50.84 0 92.05-41.2 92.05-92.03v-253.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3160",
    stroke: "none",
    d: "M1095.34 2218.91H674.906c-50.836 0-92.039 41.22-92.039 92.04v-147.09c0-50.84 41.203-92.04 92.039-92.04h420.434c50.84 0 92.05 41.2 92.05 92.04v147.09c0-50.82-41.21-92.04-92.05-92.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1051.79 2477.08H718.461c-50.836 0-92.039-41.21-92.039-92.04v-99.85c0-50.83 41.203-92.04 92.039-92.04h333.329c50.83 0 92.03 41.21 92.03 92.04v99.85c0 50.83-41.2 92.04-92.03 92.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7952c",
    stroke: "none",
    d: "M672.883 2144.79c0-12.83-10.403-23.24-23.235-23.24-12.828 0-23.226 10.41-23.226 23.24 0 12.82 10.398 23.23 23.226 23.23 12.832 0 23.235-10.41 23.235-23.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M750.703 2144.79c0-12.83-10.398-23.24-23.223-23.24-12.835 0-23.238 10.41-23.238 23.24 0 12.82 10.403 23.23 23.238 23.23 12.825 0 23.223-10.41 23.223-23.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M835.063 2147.57h-26.356v26.36h26.356v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M835.063 2108.38h-26.356v26.35h26.356v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M885.129 2147.57h-26.363v26.36h26.363v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M885.129 2108.38h-26.363v26.35h26.363v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M935.176 2147.57h-26.348v26.36h26.348v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M935.176 2108.38h-26.348v26.35h26.348v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M985.238 2147.57h-26.359v26.36h26.359v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M985.238 2108.38h-26.359v26.35h26.359v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1035.3 2147.57h-26.36v26.36h26.36v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1035.3 2108.38h-26.36v26.35h26.36v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1085.36 2147.57H1059v26.36h26.36v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1085.36 2108.38H1059v26.35h26.36v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1135.41 2147.57h-26.35v26.36h26.35v-26.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1135.41 2108.38h-26.35v26.35h26.35v-26.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d2f5f",
    stroke: "none",
    d: "M1187.39 2319.82c0 33.46-17.86 62.75-44.57 78.86-6.59 44.37-44.84 78.4-91.03 78.4H718.461c-46.199 0-84.445-34.04-91.035-78.4-26.703-16.11-44.559-45.41-44.559-78.86v97.38c0 50.83 41.203 92.03 92.039 92.03h420.434c50.84 0 92.05-41.2 92.05-92.03v-97.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232340",
    stroke: "none",
    d: "M627.426 2398.68c6.59 44.36 44.836 78.4 91.035 78.4h333.329c46.19 0 84.44-34.03 91.03-78.4-13.86 8.37-30.11 13.18-47.48 13.18H674.906c-17.371 0-33.621-4.82-47.48-13.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M691.25 1749.18h144.609v270.48H691.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M691.25 1854.96h144.609v164.699H691.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M803.203 1937.32c0-21.9-17.75-39.65-39.644-39.65-21.895 0-39.649 17.75-39.649 39.65 0 21.88 17.754 39.64 39.649 39.64 21.894 0 39.644-17.76 39.644-39.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M756.32 1917.18c0-2.8-2.277-5.08-5.09-5.08a5.08 5.08 0 00-5.078 5.08v40.26c0 2.79 2.27 5.07 5.078 5.07 2.813 0 5.09-2.28 5.09-5.07v-40.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M780.961 1917.18a5.082 5.082 0 00-10.164 0v40.26c0 2.79 2.277 5.07 5.086 5.07a5.08 5.08 0 005.078-5.07v-40.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232340",
    stroke: "none",
    d: "M835.859 1937.32h-32.656c0 21.88-17.75 39.64-39.644 39.64-21.895 0-39.649-17.76-39.649-39.64h-32.66v82.34h144.609v-82.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ca035",
    stroke: "none",
    d: "M803.203 1937.32h-22.242v20.12a5.08 5.08 0 01-5.078 5.07c-2.809 0-5.086-2.28-5.086-5.07v-20.12H756.32v20.12c0 2.79-2.277 5.07-5.09 5.07a5.078 5.078 0 01-5.078-5.07v-20.12H723.91c0 21.88 17.754 39.64 39.649 39.64 21.894 0 39.644-17.76 39.644-39.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232340",
    stroke: "none",
    d: "M756.32 1937.32h-10.168v20.12c0 2.79 2.27 5.07 5.078 5.07 2.813 0 5.09-2.28 5.09-5.07v-20.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232340",
    stroke: "none",
    d: "M780.961 1937.32h-10.164v20.12c0 2.79 2.277 5.07 5.086 5.07a5.08 5.08 0 005.078-5.07v-20.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M908.023 1749.18h144.617v270.48H908.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M908.023 1854.96h144.617v164.699H908.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7952c",
    stroke: "none",
    d: "M1019.97 1937.32c0-21.9-17.74-39.65-39.638-39.65-21.894 0-39.648 17.75-39.648 39.65 0 21.88 17.754 39.64 39.648 39.64 21.898 0 39.638-17.76 39.638-39.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7952c",
    stroke: "none",
    d: "M1801.04 2019.66c0-21.91-17.75-39.65-39.64-39.65-21.9 0-39.65 17.74-39.65 39.65 0 21.89 17.75 39.64 39.65 39.64 21.89 0 39.64-17.75 39.64-39.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#232340",
    stroke: "none",
    d: "M1052.64 1937.32h-32.67c0 21.88-17.74 39.64-39.638 39.64-21.894 0-39.648-17.76-39.648-39.64h-32.661v82.34h144.617v-82.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2802a",
    stroke: "none",
    d: "M1019.97 1937.32h-79.286c0 21.88 17.754 39.64 39.648 39.64 21.898 0 39.638-17.76 39.638-39.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M502.926 1674.7h764.414v14.04H502.926v-14.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M502.926 1574.2h764.414v14.02H502.926v-14.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31366e",
    stroke: "none",
    d: "M502.926 1473.68h764.414v14.03H502.926v-14.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27274a",
    stroke: "none",
    d: "M1244.05 1311.28H526.199v40.26h717.851v-40.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "none",
    d: "M980.332 1922.31h86.678c11.05 0 21.03-4.49 28.4-11.83 7.33-7.36 11.82-17.35 11.83-28.4v-293.76c.05-38.72 31.5-70.17 70.22-70.22h123.26c38.72.05 70.17 31.5 70.23 70.22v293.76c0 11.05 4.49 21.04 11.83 28.4 7.36 7.34 17.35 11.83 28.4 11.83h125.79c11.05 0 21.04-4.49 28.4-11.83 7.34-7.36 11.82-17.35 11.83-28.4v-47.18c.05-38.73 31.5-70.18 70.23-70.24h58.74c38.73.06 70.17 31.51 70.23 70.24v184.76c0 8.28-6.72 15-15 15-8.29 0-15-6.72-15-15V1834.9c-.01-11.05-4.5-21.05-11.84-28.41-7.36-7.34-17.34-11.83-28.39-11.83h-58.74c-11.05 0-21.04 4.49-28.4 11.83-7.34 7.37-11.83 17.36-11.83 28.41v47.18c-.06 38.72-31.5 70.18-70.23 70.23h-125.79c-38.73-.05-70.17-31.51-70.23-70.23v-293.76c-.01-11.05-4.49-21.03-11.83-28.39-7.36-7.34-17.35-11.83-28.4-11.83h-123.26c-11.05 0-21.03 4.49-28.39 11.83-7.34 7.36-11.83 17.34-11.83 28.39v293.76c-.06 38.72-31.5 70.17-70.23 70.23h-86.678c-8.285 0-15-6.71-15-15 0-8.28 6.715-15 15-15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M1031.31 2379.66H754.379v-36.61h-15.434v-46.47h15.434v-36.62h276.931v107.08zm-12.62-12.62v-94.45H767.008v36.61h-15.442v21.22h15.442v36.62h251.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M792.355 2282.33h-13.464v74.96h13.464v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M818.805 2282.33H805.32v74.96h13.485v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M845.238 2282.33h-13.476v74.96h13.476v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M871.676 2282.33h-13.473v74.96h13.473v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M898.121 2282.33h-13.492v74.96h13.492v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M924.551 2282.33H911.07v74.96h13.481v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M950.992 2282.33H937.5v74.96h13.492v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M977.422 2282.33h-13.469v74.96h13.469v-74.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc42e",
    stroke: "none",
    d: "M1003.87 2282.33h-13.487v74.96h13.487v-74.96"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8557 0 0 1.8557 -605.243 -2333.195)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 801.166,
    cy: -2697.015,
    r: 68.979,
    fill: "#fff",
    stroke: "none",
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f345c",
    d: "M792.823 2682.122H757.3v10.617h35.522zm-35.522 30.347h26.882l-5.74-10.61H757.3zm98.464-19.73v9.12h-34.6l5.745 10.61h28.804v2.155a6.963 6.963 0 01-6.967 6.963h-46.804v-9.12h13.139l-13.139-24.265v13.656H788.81l10.671 19.723-44.337.013a6.957 6.957 0 01-6.96-6.963v-12.766h-6.466v-9.119h6.467v-12.77a6.96 6.96 0 016.959-6.966h93.602a6.966 6.966 0 016.966 6.967v2.152h-45.228l5.745 10.617h39.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50bf59",
    d: "M801.941 2688.204v13.656h-13.134l10.672 19.721 2.462.013v-9.118h13.138l-13.138-24.266"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithCharger);
export default __webpack_public_path__ + "static/media/car-with-charger.bc62eefc9b2b48013a6475a3212109b5.svg";
export { ForwardRef as ReactComponent };